import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=5eba76fe"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports